export const DEFAULT_FONT = 'Montserrat';
